import { withStyles } from "@material-ui/core/styles";
import { Button as _Button } from "@material-ui/core";

export const Button = withStyles(() => ({
  root: {
    borderRadius: 40,
  },
  contained: {
    background: "linear-gradient(90.96deg, #2eefaa -3.74%, #02ba78 131.31%)",
  },
  outlined: {
    color: "#00C780",
    borderColor: "#00C780",
  },
}))(_Button);
